import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95316c90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex mb-2 pl-2" }
const _hoisted_2 = {
  key: 0,
  class: "ml-3 d-flex align-items-center"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("一鍵全部簽到 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("曠課")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("簽到")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("請假")
const _hoisted_7 = { key: 3 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 更新簽到 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 刪除簽到 ")
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = { class: "dialog-footer" }

import { ref, reactive, computed } from "vue";
import { useI18n } from "vue-i18n";
import API from '@/apis/TPSAPI';
import { M_IResDailyScheduleStatus, M_ICloseAccountDetail, M_IScheduleCheckStatus } from "@/models/M_ICloseAccount";
import { ElNotification, ElMessageBox, NotificationParams, FormInstance, FormRules } from 'element-plus';
import { Check, CircleCheck } from '@element-plus/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleCheckMgmt',
  setup(__props) {

const { t } = useI18n();
const selectedDate = ref<string>('');
const dailyScheduleStatus = ref<M_IResDailyScheduleStatus | null>(null);
const isCheckingInAll = ref<boolean>(false);
const isShowAddRoleDialog = ref<boolean>(false);
const isShowUpdateAttendanceDialog = ref<boolean>(false);
const isUpdatingAttendance = ref<boolean>(false);

const updateAttendanceForm = reactive({
  attendanceId: 0,
  studentPermissionId: 0,
  studentName: '',
  courseName: '',
  attendanceDate: '',
  attendanceType: 1
});

const createFormData = reactive<M_ICloseAccountDetail>({
  closeDate: '',
  yesterdayPettyIncome: 0,
  businessIncome: 0,
  closeAccountAmount: 0,
  depositAmount: 0,
  pettyIncome: 0
});

const rules = reactive<FormRules>({
  depositAmount: [{ required: true, message: '請輸入提存金額', trigger: 'blur' }]
});

// 自動計算零用金結餘
const computedPettyIncome = computed(() => {
  return createFormData.closeAccountAmount - createFormData.depositAmount;
});

const handleDateChange = async (date: string) => {
  if (!date) {
    dailyScheduleStatus.value = null;
    return;
  }

  let notifyParam: NotificationParams = {};

  try {
    const response = await API.getCloseAccountDailyStatus(date);

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    dailyScheduleStatus.value = response.data.content;

    notifyParam = {
      title: "查詢成功",
      type: "success",
      message: `日期：${date}<br>總課程數：${dailyScheduleStatus.value.totalSchedules}<br>已簽到：${dailyScheduleStatus.value.checkedInCount}<br>未簽到：${dailyScheduleStatus.value.notCheckedInCount}`,
      duration: 3000,
      dangerouslyUseHTMLString: true
    };

    console.log('簽到狀態:', dailyScheduleStatus.value);

  } catch (error) {
    dailyScheduleStatus.value = null;
    notifyParam = {
      title: "查詢失敗",
      type: "error",
      message: (error as Error).message,
      duration: 3000,
    };
  } finally {
    ElNotification(notifyParam);
  }
};

const handleCheckInAll = async () => {
  if (!selectedDate.value || !dailyScheduleStatus.value) {
    return;
  }

  try {
    await ElMessageBox.confirm(
      `確定要為 ${selectedDate.value} 的所有未簽到課程一鍵簽到嗎？`,
      '確認操作',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );
  } catch {
    return;
  }

  isCheckingInAll.value = true;
  let notifyParam: NotificationParams = {};

  try {
    const response = await API.checkInAllForDate(selectedDate.value);

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    const result = response.data.content;

    notifyParam = {
      title: "簽到成功",
      type: "success",
      message: `批量簽到完成<br>總課程數：${result.totalSchedules}<br>成功簽到：${result.successfulCheckins} 筆`,
      duration: 3000,
      dangerouslyUseHTMLString: true
    };

    // 重新查詢簽到狀態
    await handleDateChange(selectedDate.value);

  } catch (error) {
    notifyParam = {
      title: "簽到失敗",
      type: "error",
      message: (error as Error).message,
      duration: 3000,
    };
  } finally {
    isCheckingInAll.value = false;
    ElNotification(notifyParam);
  }
};

const handleCloseAccount = async () => {
  if (!dailyScheduleStatus.value || !dailyScheduleStatus.value.canCloseAccount || !selectedDate.value) {
    return;
  }

  let notifyParam: NotificationParams = {};

  try {
    // 查詢關帳明細資料
    const response = await API.getCloseAccountDetail(selectedDate.value);

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    const detail = response.data.content;

    // 填充表單資料
    createFormData.closeDate = detail.closeDate;
    createFormData.yesterdayPettyIncome = detail.yesterdayPettyIncome;
    createFormData.businessIncome = detail.businessIncome;
    createFormData.closeAccountAmount = detail.closeAccountAmount;
    createFormData.depositAmount = detail.depositAmount;
    createFormData.pettyIncome = detail.pettyIncome;

    // 顯示彈窗
    isShowAddRoleDialog.value = true;

  } catch (error) {
    notifyParam = {
      title: "查詢失敗",
      type: "error",
      message: (error as Error).message,
      duration: 3000,
    };
    ElNotification(notifyParam);
  }
};

const submitForm = async () => {
  if (!createFormData.closeDate) return;

  let notifyParam: NotificationParams = {};

  try {
    const response = await API.saveCloseAccount({
      date: createFormData.closeDate,
      depositAmount: createFormData.depositAmount
    });

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    notifyParam = {
      title: "關帳成功",
      type: "success",
      message: `已完成 ${createFormData.closeDate} 的關帳作業`,
      duration: 3000,
    };

    isShowAddRoleDialog.value = false;

  } catch (error) {
    notifyParam = {
      title: "關帳失敗",
      type: "error",
      message: (error as Error).message,
      duration: 3000,
    };
  } finally {
    ElNotification(notifyParam);
  }
};

const handleUpdateAttendance = (row: any) => {
  updateAttendanceForm.attendanceId = row.attendanceId;
  updateAttendanceForm.studentPermissionId = row.studentPermissionId;
  updateAttendanceForm.studentName = row.studentName;
  updateAttendanceForm.courseName = row.courseName;
  updateAttendanceForm.attendanceDate = row.scheduleDate.replace(/\//g, '-');
  console.log("updateAttendanceForm.attendanceDate", updateAttendanceForm.attendanceDate);
  updateAttendanceForm.attendanceType = row.attendanceType ?? 1;

  isShowUpdateAttendanceDialog.value = true;
};

const submitUpdateAttendance = async () => {
  let notifyParam: NotificationParams = {};
  isUpdatingAttendance.value = true;

  try {
    const response = await API.updateAttendance({
      id: updateAttendanceForm.attendanceId,
      studentPermissionId: updateAttendanceForm.studentPermissionId,
      attendanceDate: updateAttendanceForm.attendanceDate,
      attendanceType: updateAttendanceForm.attendanceType,
      modifiedUserId: 51,
      isDelete: false
    });

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    notifyParam = {
      title: "更新成功",
      type: "success",
      message: "簽到記錄已更新",
      duration: 3000,
    };

    isShowUpdateAttendanceDialog.value = false;

    // 重新查詢簽到狀態
    if (selectedDate.value) {
      await handleDateChange(selectedDate.value);
    }

  } catch (error) {
    notifyParam = {
      title: "更新失敗",
      type: "error",
      message: (error as Error).message,
      duration: 3000,
    };
  } finally {
    isUpdatingAttendance.value = false;
    ElNotification(notifyParam);
  }
};

const handleDeleteAttendance = async (row: any) => {
  try {
    await ElMessageBox.confirm(
      `確定要刪除 ${row.studentName} 在 ${row.scheduleDate} 的簽到記錄嗎？`,
      '確認刪除',
      {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );
  } catch {
    return;
  }

  let notifyParam: NotificationParams = {};

  try {
    const response = await API.updateAttendance({
      id: row.attendanceId,
      studentPermissionId: row.studentPermissionId,
      attendanceDate: row.scheduleDate.replace(/\//g, '-'),
      attendanceType: row.attendanceType ?? 1,
      modifiedUserId: 51,
      isDelete: true
    });

    if (response.data.result !== 1) {
      throw Error(response.data.msg);
    }

    notifyParam = {
      title: "刪除成功",
      type: "success",
      message: "簽到記錄已刪除",
      duration: 3000,
    };

    // 重新查詢簽到狀態
    if (selectedDate.value) {
      await handleDateChange(selectedDate.value);
    }

  } catch (error) {
    notifyParam = {
      title: "刪除失敗",
      type: "error",
      message: (error as Error).message,
      duration: 3000,
    };
  } finally {
    ElNotification(notifyParam);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_date_picker, {
        modelValue: selectedDate.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
        type: "date",
        placeholder: "查詢簽到狀態",
        format: "YYYY-MM-DD",
        "value-format": "YYYY-MM-DD",
        style: {"width":"220px"},
        onChange: handleDateChange
      }, null, 8, ["modelValue"]),
      (dailyScheduleStatus.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!dailyScheduleStatus.value.canCloseAccount)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  size: "small",
                  onClick: handleCheckInAll,
                  loading: isCheckingInAll.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CircleCheck))
                      ]),
                      _: 1
                    }),
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: handleCloseAccount,
              disabled: !dailyScheduleStatus.value.canCloseAccount
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Check))
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(dailyScheduleStatus.value.canCloseAccount ? '今日關帳' : '無法關帳'), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              name: "scheduleCheckTable",
              style: {"width":"100%"},
              height: "500",
              data: dailyScheduleStatus.value?.scheduleStatuses,
              "empty-text": "請選擇日期查詢簽到狀態"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "學生編號",
                  prop: "username"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "學生名稱",
                  prop: "studentName"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "課程名稱",
                  prop: "courseName"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "教室",
                  prop: "classroomName"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "課程時間"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.startTime) + " ~ " + _toDisplayString(scope.row.endTime), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "簽到狀態",
                  prop: "status",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_tag, {
                      type: scope.row.status === '已簽到' ? 'success' : 'error'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.status), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "",
                  label: "簽到類型",
                  prop: "attendanceType",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.attendanceType === 0)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "danger"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }))
                      : (scope.row.attendanceType === 1)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }))
                        : (scope.row.attendanceType === 2)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 2,
                              type: "warning"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "簽到時間",
                  prop: "checkedInTime"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.checkedInTime ? new Date(scope.row.checkedInTime).toLocaleString('zh-TW') : '-'), 1)
                  ]),
                  _: 1
                }),
                true
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      label: "操作",
                      align: "center",
                      width: "180"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.attendanceId)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              size: "small",
                              onClick: ($event: any) => (handleUpdateAttendance(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (scope.row.attendanceId)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              type: "danger",
                              size: "small",
                              onClick: ($event: any) => (handleDeleteAttendance(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: isShowUpdateAttendanceDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isShowUpdateAttendanceDialog).value = $event)),
      title: "更新簽到",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (isShowUpdateAttendanceDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitUpdateAttendance,
            loading: isUpdatingAttendance.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          model: updateAttendanceForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "學生名稱" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: updateAttendanceForm.studentName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updateAttendanceForm.studentName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "課程名稱" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: updateAttendanceForm.courseName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((updateAttendanceForm.courseName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "簽到日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: updateAttendanceForm.attendanceDate,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((updateAttendanceForm.attendanceDate) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "簽到類型",
              prop: "attendanceType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: updateAttendanceForm.attendanceType,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((updateAttendanceForm.attendanceType) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "曠課",
                      value: 0
                    }),
                    _createVNode(_component_el_option, {
                      label: "簽到",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "請假",
                      value: 2
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: isShowAddRoleDialog.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((isShowAddRoleDialog).value = $event)),
      title: "關帳"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (isShowAddRoleDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (submitForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref: "",
          rules: rules,
          model: createFormData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "關帳日期",
              prop: "closeDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.closeDate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((createFormData.closeDate) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "昨日現金結餘",
              prop: "yesterdayPettyIncome"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.yesterdayPettyIncome,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((createFormData.yesterdayPettyIncome) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "營業收入",
              prop: "businessIncome"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.businessIncome,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((createFormData.businessIncome) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "關帳結算金額",
              prop: "closeAccountAmount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: createFormData.closeAccountAmount,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((createFormData.closeAccountAmount) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "提存金額",
              prop: "depositAmount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  style: {"width":"90%"},
                  modelValue: createFormData.depositAmount,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((createFormData.depositAmount) = $event)),
                  min: 0,
                  controls: false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "零用金結餘",
              prop: "pettyIncome"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  value: _unref(computedPettyIncome),
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})